import { isBrandingDesktopAdUnit, isMailAdUnit, Collapse } from 'mk/ox/hbAdUnits';
import { ScreenSizes } from 'mk/ox/hbSizes';
import { cacheLast } from 'mk2/helpers/cache';

const maxHeightWithAdCache = cacheLast(true);

function getMaxHeightWithAdUncached(adUnit, isMobile) {
    const displayAdSlotPlaceholder = adUnit.collapse === Collapse.NEVER || adUnit.collapse === Collapse.AFTER_FETCH;
    if (displayAdSlotPlaceholder) {
        let maxScreenHeight = null;
        const screenWidth = typeof window !== 'undefined'
            ? document.body.clientWidth
            : isMobile ? 599 : 980;
        adUnit.sizeMapping.forEach((sm: ScreenSizes) => {
            if (sm.minScreenWidth <= screenWidth) {
                sm.sizesSupported.forEach((ss: googletag.SingleSize) => {
                    if (
                        Array.isArray(ss) && (ss[1] > maxScreenHeight || maxScreenHeight === null)
                        // handling branding/mail AdUnit, which have specially set height
                        && !(ss[1] === 1400 && isBrandingDesktopAdUnit(adUnit.code))
                        && !(isMailAdUnit(adUnit.code))
                    ) {
                        maxScreenHeight = ss[1];
                    }
                });
            }
        });
        return [82, 125, 250, 280, 300, 600].includes(maxScreenHeight) ? maxScreenHeight : null;
    }
    return null;
}


export function getMaxHeightWithAd(adUnit, isMobile) {
    return maxHeightWithAdCache(() => getMaxHeightWithAdUncached(adUnit, isMobile), adUnit.code, typeof window);
}

